const R = require('ramda')

module.exports = R.pipe(
  require('./dataAccess/installClient'),
  require('./view/installClient'),
)
